import dayjs from 'dayjs';

import { MonthWithWeeks, TableCell } from './booking-types';

const MONTH_CONVERSION = [6, 0, 1, 2, 3, 4, 5]; //Mon to Sun indexes of the js Date indexes

export const splitMonthIntoWeeks = (year: number, monthIndex: number, name: string, month: TableCell[]): MonthWithWeeks => {
  const table42Cells: TableCell[] = Array(42).fill({ day: ' ', status: 'c' });
  const firstDayOfMonth = dayjs(`${year}-${monthIndex + 1}-01`, 'YYYY-M-DD');
  const dayIndex = MONTH_CONVERSION[firstDayOfMonth.day()];

  const converted42Cells = [...table42Cells.slice(0, dayIndex)].concat([...month]).concat([...table42Cells.slice(dayIndex + month.length)]);

  const weeks = [];

  let index = 0;
  while (converted42Cells.length > 0) {
    const week = converted42Cells.splice(0, 7);
    weeks[index] = week;
    index++;
  }
  return { name, weeks };
};
